module.exports = __webpack_public_path__ + "static/media/murphy-ireland.a793bead.png";